import { Controller as BaseController } from 'stimulus'
import I18n from '@app/javascript/i18n/index.js.erb'

export class Controller extends BaseController {
  static targets = ['togglerButton']

  connect() {
    this.togglerButtonOriginalLabel = this.togglerButtonLabel.innerHTML
  }

  submitting() {
    this.togglerButtonTarget.disabled = true
    this.togglerButtonLabel.innerHTML = I18n.t('common.submitting_ellipsis')
  }

  submittingDone() {
    this.togglerButtonTarget.disabled = false
    this.togglerButtonLabel.innerHTML = this.togglerButtonOriginalLabel
  }

  get togglerButtonLabel() {
    return this.togglerButtonTarget.querySelector('.button-label')
  }
}
